/** In-memory store. Writes mutate it; a reload re-seeds from fixtures. */

import { createDemoData, type DemoData, type DemoSeason } from "./fixtures";

// One-shot: set by the banner before a role-switch reload, consumed on the way
// back in. A plain refresh finds nothing and still resets the season.
const SEASON_HANDOVER_KEY = "demoSeasonHandover";

const data: DemoData = createDemoData();

export function getData(): DemoData {
  return data;
}

export function stashSeasonForRoleSwitch(): void {
  try {
    sessionStorage.setItem(SEASON_HANDOVER_KEY, JSON.stringify(data.season));
  } catch {
    // Private mode: losing the handover just means the season resets.
  }
}

export function applyStashedSeason(): void {
  try {
    const raw = sessionStorage.getItem(SEASON_HANDOVER_KEY);
    if (!raw) return;
    sessionStorage.removeItem(SEASON_HANDOVER_KEY);
    Object.assign(data.season, JSON.parse(raw) as DemoSeason);
  } catch {
    sessionStorage.removeItem(SEASON_HANDOVER_KEY);
  }
}

applyStashedSeason();

/** Restores the seed data without a reload. */
export function resetDemoData(): void {
  const fresh = createDemoData();
  data.users = fresh.users;
  data.pickups = fresh.pickups;
  data.pickupLocations = fresh.pickupLocations;
  data.subscriptions = fresh.subscriptions;
  data.tiers = fresh.tiers;
  data.harvestProducts = fresh.harvestProducts;
  data.harvestLogs = fresh.harvestLogs;
  data.orders = fresh.orders;
  data.events = fresh.events;
  data.season = fresh.season;
}

export function findUser(userId: string) {
  return data.users.find((u) => u._id === userId);
}

export function findUserByCompanyRegistrationNumber(registrationNumber: string) {
  return data.users.find(
    (u) => u.companyRegistrationNumber === registrationNumber,
  );
}

export function userHasPickup(userId: string): boolean {
  return data.pickups.some((p) => p.userId === userId);
}

export function subscriberCountByTierId(): Record<string, number> {
  return data.pickups.reduce<Record<string, number>>((acc, pickup) => {
    acc[pickup.subscriptionTierId] = (acc[pickup.subscriptionTierId] ?? 0) + 1;
    return acc;
  }, {});
}
